/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class LogApi {
    static getInstance() {
        if (!this.instance) this.instance = new LogApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取报错日志
    async getLogList (param, page_num, page_size){
        let url = `/api/log/error/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取物流公司下拉
    async getCourierType (param,id){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取订单来源
    async getOrderSource (param){
        // let url = `/api/system/source`
        // let result = await this.getData(url,param,'GET')
        // return result

        let url = `/api/system/source/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取操作日志
    async getRiskVerificationLogLog (param, page_num, page_size){
        let url = `/api/system/operation/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    } 
}

export {
    LogApi
}